/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Save_Point_2Inputs */

const en_services_svc_save_point_2 = /** @type {(inputs: Services_Svc_Save_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enquiry routing, follow-ups and email automation`)
};

const lv_services_svc_save_point_2 = /** @type {(inputs: Services_Svc_Save_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pieprasījumu novirzīšana, atgādinājumi un e-pasta automatizācija`)
};

/**
* | output |
* | --- |
* | "Enquiry routing, follow-ups and email automation" |
*
* @param {Services_Svc_Save_Point_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_save_point_2 = /** @type {((inputs?: Services_Svc_Save_Point_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Save_Point_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_save_point_2(inputs)
	return en_services_svc_save_point_2(inputs)
});